// TODO: Use sentry/react-native for mobile app instead of @sentry/browser
import * as Sentry from '@sentry/browser'

let isInitialized = false

const getSentryEnvironment = () => {
  if (window.config && window.config.sentryEnvironment) {
    return String(window.config.sentryEnvironment)
  }
  if (window.config && window.config.titleSuffix) {
    return String(window.config.titleSuffix).toLowerCase()
  }
  return 'unknown'
}

const getSentryRelease = (app: 'web' | 'mobile') => {
  const appVersion = window.appVersion
  const buildVersion = window.buildVersion

  if (!appVersion) return undefined
  if (app === 'mobile' && buildVersion != null) {
    return `card-mobile@${String(appVersion)}+${String(buildVersion)}`
  }
  return `card-${app}@${String(appVersion)}`
}

export const initSentry = ({
  dsn,
  app
}: {
  dsn: string | null | undefined,
  app: 'web' | 'mobile'
}) => {
  if (!dsn || isInitialized) return

  Sentry.init({
    dsn,
    environment: getSentryEnvironment(),
    release: getSentryRelease(app)
  })

  Sentry.configureScope(scope => {
    scope.setTag('app', app)
    scope.setTag('platform', String(window.platform || app))
    if (window.appVersion != null) {
      scope.setTag('app-version', String(window.appVersion))
    }
    if (window.buildVersion != null) {
      scope.setTag('build-version', String(window.buildVersion))
    }
  })

  isInitialized = true
}

export default Sentry
